import { useQuery } from '@tanstack/react-query';
import { isError, type Result } from '@synqo/frontend-component-library';
import { usePermissionsRepository } from '@Hooks/useRepository';
import { OwnProfileRepository } from '@Repositories/Permissions';
import { type ApiUserInformation } from '@Model';
import { useIsAuthenticated } from '@azure/msal-react';

export const useUserInformation = () => {
    const ownProfile = usePermissionsRepository(OwnProfileRepository);
    const isAuthenticated = useIsAuthenticated();

    const {
        data: result,
        isLoading,
        isError: isQueryError,
        refetch,
    } = useQuery<Result<ApiUserInformation>, unknown, Result<ApiUserInformation>>({
        queryKey: ['permissions', 'user'],
        queryFn: () => ownProfile.getMyUserInformation(),
        enabled: isAuthenticated,
    });

    return {
        isLoading,
        isError: isQueryError || (result !== undefined && isError(result)),
        data: result?.data,
        refetch,
    };
};
